module.exports = __webpack_public_path__ + "static/media/refresh.50e62bee.svg";